/**
 * Waga priorytetu klienta na karcie kontrahenta (07.10.2026).
 *
 * Odpowiedź Marathonu: „Zostawiamy miejsce na wagi priorytetu klienta.
 * Sposób obliczenia poda dział CS w kolejnym etapie. Póki co wszyscy klienci
 * niech mają wagę max.” API oddaje gotową wagę z regułą „pusta = max”
 * (`contractors/customer-priority.ts`) — front nie trzyma kopii skali.
 * Waga nie wpływa na kolejność rekomendacji; edycji nie ma, dopóki CS nie
 * poda reguły.
 */

export interface CustomerPriority {
  weight: number;
  max: number;
  /** Nieustalona — przyjęto max. */
  assumed: boolean;
}

function isCustomerPriority(v: unknown): v is CustomerPriority {
  if (typeof v !== 'object' || v === null) return false;
  const p = v as Record<string, unknown>;
  return (
    typeof p.weight === 'number' &&
    typeof p.max === 'number' &&
    typeof p.assumed === 'boolean'
  );
}

/** Tekst do wiersza „Priorytet klienta”; bez danych z API — kreska. */
export function customerPriorityText(value: unknown): string {
  if (!isCustomerPriority(value)) return '—';
  if (value.assumed) return 'max (do ustalenia przez CS)';
  if (value.weight === value.max)
    return `max (${value.weight} na ${value.max})`;
  return `${value.weight} na ${value.max}`;
}
